import { Navigate, useRoutes } from "react-router-dom"
import LoginView from "../views/login";
import NotFoundView from "../views/404";
import DashboardView from "../views/dashboard";
import { ProtectedRoute } from "./protectedRoute";
import ChangePasswordView from "../views/changePassword";
import OrderView from "../views/order";
import SalesReportView from "../views/reports/sales";
import HomeView from "../views/home";
import { COUPON_ROUTE, DRIVER_REPORT_ROUTE, INVOICE, LOGIN_ROUTE, MERCHANT_DETAIL, MERCHANT_USER_ROUTE, ORDER_DETAIL_ROUTE, ORDER_ROUTE, PAYMENT_REPORT_ROUTE, PROFILE_DETAIL, PROMOTION_ROUTE, SALES_REPORT_ROUTE } from "./paths";
import ProductMerchantView from "../views/productMerchant";
import CategoryBranchView from "../views/categoryBranch";
import MerchantUserView from "../views/merchantUser";
import ReturnOrderView from "../views/returnOrder";
import { useEffect, useState } from "react";
import { MerchantUserModel } from "../models/merchantUser";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import axios from "../lib/axios";
import { increaseNotification } from "../store/notification_slice";
import MerchantDetailView from "../views/merchant";
import { checkPermission } from "../utils/checkPermission";
import InvoiceView from "../views/invoice";
import ProfileDetailPage from "../views/profile_detail";


export default function Router() {
    const authData: MerchantUserModel = useSelector((state: RootState) => state?.auth?.data || null!)
    return useRoutes([
        {
            path: '/',
            element: <ProtectedRoute><DashboardView /></ProtectedRoute>,
            children: [
                {
                    element: <Navigate to="home" replace />, index: true
                },
                {
                    path: 'home',
                    element: <HomeView />
                },
                {
                    path: INVOICE,
                    element: <InvoiceView />
                },
                {
                    path: 'changePassword',
                    element: <ChangePasswordView />
                },

                {
                    path: 'productMerchant',
                    element: <ProductMerchantView />
                },
                {
                    path: 'categoriesBranch',
                    element: <CategoryBranchView />
                },
                {
                    path: ORDER_ROUTE,
                    element: <OrderView />
                },
                {
                    path: 'return-order',
                    element: <ReturnOrderView />
                },
                {
                    path: PROFILE_DETAIL,
                    element: <ProfileDetailPage />
                },
                {
                    path: SALES_REPORT_ROUTE,
                    element: checkPermission(authData?.role?.role_type, SALES_REPORT_ROUTE) ? <SalesReportView /> : <Navigate to={LOGIN_ROUTE} replace />
                },
                {
                    path: MERCHANT_USER_ROUTE,
                    element: checkPermission(authData?.role?.role_type, MERCHANT_USER_ROUTE) ? <MerchantUserView /> : <Navigate to={LOGIN_ROUTE} replace />
                },
                {
                    path: MERCHANT_DETAIL,
                    element: checkPermission(authData?.role?.role_type, MERCHANT_DETAIL) ? <MerchantDetailView /> : <Navigate to={LOGIN_ROUTE} replace />
                }
            ]
        },
        {
            path: LOGIN_ROUTE,
            element: <LoginView />
        },
        {
            path: "/404",
            element: <NotFoundView />
        },
        { path: '*', element: <Navigate to="/404" replace /> },
    ]);
}